import { register } from 'register-service-worker'

// Questo assicura che il Service Worker non rompa le scatole mentre sviluppi
// if (process.env.NODE_ENV === 'production') {
// }

register(`${process.env.BASE_URL}service-worker.js`, {
  updated(registration) {
    document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
  },
  error(error) { console.error('Errore SW:', error); }
});